import WrapWithDropdownBody from "../WrapWithDropdownBody.vue";
import { SelectedSection } from "../sections";
import CustomFilterItem from "../items/CustomFilterItem.vue";
import ListSection from "../sections/ListSection.vue";
export default {
  name: "CustomFilterBody",
  components: {
    WrapWithDropdownBody,
    SelectedSection,
    CustomFilterItem,
    ListSection
  },
  emits: ["clear", "restoreSearch", "select", "selectOnly", "deselect", "apply", "search", "hidden", "closeDropdown"],
  props: {
    title: {
      type: String,
      default: ""
    },
    selected: {
      type: Array,
      default: () => []
    },
    list: {
      type: Array,
      default: () => []
    },
    isModified: {
      type: Boolean,
      default: false
    },
    searching: {
      type: Boolean,
      default: false
    },
    isSearching: {
      type: Boolean,
      default: false
    },
    keyword: {
      type: [String, Array],
      default: ""
    },
    search_placeholder: {
      type: String,
      default: "Search items"
    },
    item_key: {
      type: String,
      default: 'item'
    },
    item_name: {
      type: String,
      default: 'item_name'
    }
  }
};